const Model = require("../types/Model.js");

module.exports = Model({
	name: "versioninfo",
	init: init
});

function init() {
	const {version, build} = this.config;
	return this.api.people.version({
		version,
		build
	});
}
